(() => {
  const storageKey = 'pumiii_quickshield_cart_backup_v1';
  const root = () => window.Shopify?.routes?.root || '/';
  const cart = async () => {
    const response = await fetch(`${root()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  };
  const post = async (path, body) => {
    const response = await fetch(`${root()}cart/${path}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(`Unable to ${path} cart`);
    return response.json();
  };
  const saved = () => {
    try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); }
    catch { return null; }
  };
  const write = (value) => localStorage.setItem(storageKey, JSON.stringify(value));
  const clearBackup = () => localStorage.removeItem(storageKey);
  const sameLines = (left, right) =>
    left.length === right.length && left.every((line) =>
      right.some((other) => other.key === line.key && other.quantity === line.quantity)
    );
  let restoring = false;

  const restore = async () => {
    const backup = saved();
    if (restoring || !backup || Date.now() - backup.createdAt > 24 * 60 * 60 * 1000) {
      if (backup && Date.now() - backup.createdAt > 24 * 60 * 60 * 1000) clearBackup();
      return;
    }
    restoring = true;
    try {
      const current = await cart();
      if (sameLines(current.items, backup.original)) {
        clearBackup();
        return;
      }
      if (backup.isolated && current.item_count && !sameLines(current.items, backup.isolated)) {
        // The shopper changed the cart after starting checkout; leave that choice alone.
        clearBackup();
        return;
      }
      await post('clear', {});
      const items = backup.original.map((item) => {
        const line = { id: item.variant_id, quantity: item.quantity, properties: item.properties || {} };
        const sellingPlan = item.selling_plan_allocation?.selling_plan?.id;
        if (sellingPlan) line.selling_plan = sellingPlan;
        return line;
      });
      if (items.length) await post('add', { items });
      clearBackup();
      if (location.pathname.replace(/\/$/, '') === `${root()}cart`.replace(/\/$/, '')) {
        location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: await cart() } }));
      }
    } catch (error) {
      console.error('PUMIII cart restoration failed', error);
    } finally {
      restoring = false;
    }
  };

  window.PumiiiCartIsolation = {
    cart,
    async prepare(original) {
      if (!original.item_count) return;
      if (saved()) throw new Error('A cart checkout is already being prepared');
      write({ createdAt: Date.now(), original: original.items, isolated: null });
      const empty = await post('clear', {});
      if (empty.item_count !== 0) throw new Error('Cart did not clear');
    },
    async complete() {
      const isolated = await cart();
      if (!isolated.item_count) throw new Error('Kit was not added');
      const backup = saved();
      if (backup) write({ ...backup, isolated: isolated.items });
      return isolated;
    },
    restore,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore, { once: true });
  } else {
    restore();
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') restore();
  });
})();
